import {NgModule}                           from '@angular/core';
import {Route, RouterModule}                from '@angular/router';
import {ApCropGroupsOverviewComponent}      from './components/cropgroups/ap-cropgroups.component';
import {PageMode}                           from '../ap-interface';
import {ApLoggerSettingsComponent}          from './components/ap-logger-settings.component';
import {ApLicenceComponent}                 from './components/licence-management/ap-licence.component';
import {ApAccessPermissionsComponent}       from './components/access-permissions/ap-access-permissions.component';
import {ApPermissionGuard}                  from '../guards/ap-permission-guard.service';
import {ApUserProfileUserSettingsComponent} from './components/ap-userprofile-usersettings.component';
import {ApSettingsEditComponent}            from '../entry-components/ap-settings-entry-components/ap-settings-edit.component';

const routes: Route[] = [
  {
    path: 'general',
    component: ApSettingsEditComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
    }
  },
  {
    path: 'presentation',
    component: ApCropGroupsOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'logger',
    component: ApLoggerSettingsComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
    }
  },
  {
    path: 'license',
    component: ApLicenceComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'groups-rights',
    component: ApAccessPermissionsComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'user-profile',
    component: ApUserProfileUserSettingsComponent,
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ApSettingsRoutes {
}
